<lib-fiegerCalculatorCore [platform]="'mobile'" ></lib-fiegerCalculatorCore>

